module.exports = __webpack_public_path__ + "img/maoluhuangzhong.a1855daf.png";